import { render, staticRenderFns } from "./VenueTraining.vue?vue&type=template&id=51839362"
import script from "./VenueTraining.vue?vue&type=script&lang=js"
export * from "./VenueTraining.vue?vue&type=script&lang=js"
import style0 from "./VenueTraining.vue?vue&type=style&index=0&id=51839362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports